export var DEPLOY_DATE = new Date('2026-05-08T09:14:08+0000');
